/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { Column } from 'react-table';
import Utils from 'utils/Utils';
import MonsterOpen5e from 'model/formats/MonsterOpen5e';

export const monsterGridColumns = [
  { width: 40, Header: 'CR', accessor: 'cr',
    sortType: (rowA: { original: { cr: any; }; }, rowB: { original: { cr: any; }; }) => {
      const crA = rowA.original.cr;
      const crB = rowB.original.cr;
      return crA > crB ? 1 : crA < crB ? -1 : 0;
    },
    Cell: ({value}) => {return <div style={{textAlign: 'right', paddingRight: '15px'}}>{value}</div>}
  },
  { width: 200, Header: 'Name', accessor: 'name' },
  { width: 70, Header: 'Source', accessor: 'document__slug' },
  { width: 100, Header: 'Type', accessor: 'type' },
  { width: 100, Header: 'Size', accessor: 'size',
    sortType: (rowA: { values: { size: string; }; },
               rowB: { values: { size: string; }; }) => Utils.sortSizes(rowA.values.size, rowB.values.size)
  },
  { width: 150, Header: 'Alignment', accessor: 'alignment',
    sortType: (rowA: any, rowB: any, columnId: number) => {
      const a = rowA.values[columnId].toLowerCase();
      const b = rowB.values[columnId].toLowerCase();
      return a.localeCompare(b);
    },
    Cell: ({ value }) => {
      if (typeof value === 'string') {
        // Capitalize the first letter of each word
        value = value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
      }
      return <span>{value}</span>;
    },
  },
  { width: 250, Header: 'Environments', accessor: 'environments',
    sortType: (rowA: any, rowB: any, columnId: number) => {
      const prep = (val: any) => {
        if (Array.isArray(val)) {
          return val.map((v: string) => v.toLowerCase()).sort().join(', ');
        }
        return val ? String(val).toLowerCase() : '';
      }
      const a = prep(rowA.values[columnId]);
      const b = prep(rowB.values[columnId]);
      return a.localeCompare(b);
    },
    Cell: ({ value }) => {
      if (Array.isArray(value)) {
        const sortedValue = value.sort((a:any, b:any) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
        return <span>{sortedValue.join(', ')}</span>;
      }
      return value;
    },
  },
  { width: 40, Header: 'HP', accessor: 'hit_points',
    Cell: ({value}) => {return <div style={{textAlign: 'right', paddingRight: '15px'}}>{value}</div>} },
  { width: 40, Header: 'AC', accessor: 'armor_class' },
] as Column<MonsterOpen5e>[];
